<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Bordereaux Status</h5>

    <GroupedOptions
      @input="(value) => $emit('input', value)"
      :value="value"
      :options="options"
      :disabled="disabled"
      native-type="radio"
      button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
    />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import GroupedOptions from '@components/GroupedOptions'

export default defineComponent({
  name: 'SaveReportWizardBordeauxStatusFilters',
  components: {
    GroupedOptions
  },
  emits: ['input'],
  props: {
    value: String,
    disabled: {
			type: Boolean,
			default: () => false,
		}
  },
  setup() {
    const options = ['Active', 'Inactive', 'All'].map((value) => ({
      value,
      label: value
    }))

    return {
      options
    }
  }
})
</script>
